import { EMPTY_MULTI_VALUE, EMPTY_SINGLE_VALUE } from './select.constants';

/**
 * Normalize controlled value based on selection mode.
 *
 * @param {string | number | '' | Array<string | number> | null | undefined} value
 * @param {boolean} multiple
 * @returns {string | number | '' | Array<string | number>}
 */
export function normalizeValue(value, multiple) {
  return multiple
    ? Array.isArray(value)
      ? value
      : EMPTY_MULTI_VALUE
    : (value ?? EMPTY_SINGLE_VALUE);
}

/**
 * Check if a value represents an empty selection.
 *
 * @param {string | number | '' | Array<string | number>} value
 * @param {boolean} multiple
 * @returns {boolean}
 */
export function isEmptyValue(value, multiple) {
  return multiple ? value.length === 0 : value === EMPTY_SINGLE_VALUE;
}

/**
 * Default renderValue resolver.
 *
 * @param {Object} params
 * @param {{ label: string, value: string | number }[]} params.options
 * @param {string} params.placeholder
 * @param {boolean} params.multiple
 * @returns {(value: any) => string}
 */
export function getDefaultRenderValue({ options, placeholder, multiple }) {
  const map = new Map(options.map((o) => [o.value, o.label]));

  return (selected) => {
    if (multiple) {
      if (!Array.isArray(selected) || selected.length === 0) {
        return placeholder;
      }
      return selected
        .map((v) => map.get(v))
        .filter(Boolean)
        .join(', ');
    }

    if (selected === '' || !map.has(selected)) {
      return placeholder;
    }

    return map.get(selected);
  };
}
